//Formik
import { useField } from "formik"

//FormikHelpers
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"
import FormikDropDown from "../../../helpers/formikInputs/FormikDropDown"

//Housing components
import { getDayOfWeekOptions, getDayOfMonthOptions } from "../shared"

export default function HousingActivitiesMedicineInputs({ values, disabled }) {
  const [, , frequencyOtherHelper] = useField(
    "medicineManagement.dispensingFrequencyOther"
  )
  const [, , frequencyIntervalHelper] = useField(
    "medicineManagement.dispensingFrequencyInterval"
  )

  if (values.activityType === "MedicineManagement") {
    const isWeekly = values.medicineManagement.dispensingFrequency === "Weekly"
    const isMonthly =
      values.medicineManagement.dispensingFrequency === "Monthly"
    const frequencyIntervalText = isWeekly ? "week" : "month"

    return (
      <>
        <FormikTextInput
          disabled={disabled}
          name={"medicineManagement.type"}
          label={"Medication Type"}
          required={true}
          placeholderText={" "}
        />
        <FormikDropDown
          disabled={disabled}
          name={"medicineManagement.storage"}
          label={"Medication Storage"}
          options={[
            { label: "house stored", value: "house" },
            { label: "participant stored", value: "participant" },
          ]}
          required={true}
        />
        <FormikDropDown
          disabled={disabled}
          name={"medicineManagement.dispensing"}
          label={"Medication Dispensing"}
          options={[
            { label: "House dispended", value: "house" },
            { label: "Participant dispended", value: "participant" },
          ]}
          required={true}
        />
        <FormikDropDown
          disabled={disabled}
          name={"medicineManagement.dispensingFrequency"}
          label={"Dispensing Frequency"}
          options={[
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Other", value: "Other" },
          ]}
          required={true}
          onChangeCallback={(value) => {
            switch (value) {
              case "Daily":
                frequencyIntervalHelper.setValue("")
                frequencyOtherHelper.setValue("")
                break
              case "Weekly":
              case "Monthly":
                frequencyOtherHelper.setValue("")
                break
              default:
                frequencyIntervalHelper.setValue("")
                break
            }
          }}
        />
        {values.medicineManagement.dispensingFrequency === "Other" ? (
          <FormikTextInput
            disabled={disabled}
            name={"medicineManagement.dispensingFrequencyOther"}
            label={"Other Dispensing Frequency Description"}
            placeholderText={" "}
            required={true}
          />
        ) : null}
        {isWeekly || isMonthly ? (
          <FormikDropDown
            disabled={disabled}
            name={"medicineManagement.dispensingFrequencyInterval"}
            options={isWeekly ? getDayOfWeekOptions() : getDayOfMonthOptions()}
            label={`Day of the  ${frequencyIntervalText}`}
            placeholderText={`Please select a day of the ${frequencyIntervalText}`}
            required={true}
          />
        ) : null}
      </>
    )
  } else {
    return null
  }
}
